const vending = {
  methods: {
    getManufacturerName(n) {
      return n === "tcn" ? "TCN" : "?";
    }
  }
};

export { vending };
